export class Pregunta{
    frequentAskID: number; 
    frequentAskTitle: string;
    answer: string;
}